import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Button, Card, Space, Spin, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import CrmActivityForm from '@/components/crm/activities/CrmActivityForm';
import { useCrmActivity } from '@/hooks/useCrmActivities';

const { Title } = Typography;

/** Full-page "Log activity" (optionally pre-linked with ?lead_id= / ?opportunity_id= / ?customer_id=). */
const CrmActivityFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { data: activity, isLoading } = useCrmActivity(id);
  const [params] = useSearchParams();
  const link = {
    lead_id: params.get('lead_id'),
    opportunity_id: params.get('opportunity_id'),
    customer_id: params.get('customer_id'),
    demo_id: params.get('demo_id'),
  };
  const hasLink = !!(link.lead_id || link.opportunity_id || link.customer_id);
  const returnTo = params.get('return_to') || '/growth/activities';

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(returnTo)}>
          Back
        </Button>
      </Space>
      <Title level={3}>{id ? 'Edit sales activity' : 'Log sales activity'}</Title>
      <Card>
        {id && isLoading ? (
          <Spin />
        ) : (
          <CrmActivityForm
            activity={activity}
            link={hasLink ? link : undefined}
            defaultTypeCode={params.get('type') ?? undefined}
            defaultActivityDate={params.get('at')}
            submitLabel={id ? 'Save changes' : 'Save activity'}
            onSaved={id ? () => navigate(returnTo) : undefined}
            onCancel={() => navigate(returnTo)}
          />
        )}
      </Card>
    </div>
  );
};

export default CrmActivityFormPage;
